import { render, staticRenderFns } from "./ContributionsNavigation.vue?vue&type=template&id=08eaaa3f&scoped=true"
import script from "./ContributionsNavigation.vue?vue&type=script&lang=ts"
export * from "./ContributionsNavigation.vue?vue&type=script&lang=ts"
import style0 from "./ContributionsNavigation.vue?vue&type=style&index=0&id=08eaaa3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eaaa3f",
  null
  
)

export default component.exports